const APPLICATION_URL =
  process.env.REACT_APP_NODE_ENV === "dev"
    ? "https://logmonitoringbackend.ondchub.com"
    : process.env.REACT_APP_NODE_ENV === "staging"
    ? "https://logmonitoringbackend.ondchub.com"
    : "https://logmonitoringbackend.ondchub.com";
export const endpoint = {
  APPLICATION_URL,

  API_BASE_URL: `${APPLICATION_URL}/api/v1`,

  // End POINT
  LOGIN: "/auth/login",
  LOGOUT: "/auth/logout",

  GET_ENVIRONMENTS: "/environments",
  GET_CLIENTS: "/clients",

  GET_TRANSACTION_LOGS: "/transaction-logs/get",
  GET_APPLICATION_LOGS: "/application-logs/get",
  CLEAR_LOGS: "/dashboard/clear-logs",
  GET_QC: "/qc/getQCStoreSummaries",
  GET_BUYER_QC: "/qc/getQCBuyerAppSummaries",

};
